import { ConversationCreateExpression } from "../../../Models/Conversations/ConversationCreateExpression";
import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { ApiServices, ApiServicesKey } from "../DomainServices/DomainServiceOperationCallExpressionEvaluator";

export class ConversationCreateExpressionEvaluator implements IExpressionEvaluator<ConversationCreateExpression> {
    get type(): string {
        return "Conversation.Create";
    }

    async evaluate(expression: ConversationCreateExpression, context: IExpressionEvaluatorContext): Promise<any> {
        const { conversationClient, errorHandler } = context.GetProperty<ApiServices>(ApiServicesKey);

        try {
            const name = expression.Name ? await context.Evaluator.evaluate(expression.Name, context) : undefined;

            const participantAgentId = expression.ParticipantAgentId ? await context.Evaluator.evaluate(expression.ParticipantAgentId, context) : undefined;

            const attributeValue = expression.AttributeValue ? await context.Evaluator.evaluate(expression.AttributeValue, context) : undefined;

            const conversation = await conversationClient.create(undefined, {
                name: name,
                participantAgentId: participantAgentId,
                attributeKey: expression.AttributeKey,
                attributeValue: attributeValue,
            });

            return conversation;
        } catch (error) {
            errorHandler(error);
            throw error;
        }
    }
}
